<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    background
    :pager-count="5"
    layout="prev, pager, next"
    :total="total_page_number"
    :page-size="1"
    :key="changeCount"
  >
  </el-pagination>
</template>
<script>
import bus from "@/assets/js/bus";

export default {
  name: "ModelPagination",
  data() {
    return {
      current_page_number: 1,
      total_page_number: 0,
      stock_models: [],
      changeCount: 0
    };
  },
  methods: {
    handleSizeChange(current_page) {
      console.log("handleSizeChange!");
    },
    handleCurrentChange(current_page) {
      console.log("handleCurrentChange!");
      console.log(this.stock_models[current_page - 1]);
      bus.$emit("current_stock_model", this.stock_models[current_page - 1]);
    }
  },
  created() {
    bus.$on("stock_models", data => {
      this.total_page_number = data.length;
      this.current_page_number = 1;
      this.changeCount++;
      this.stock_models = data;
      // console.log("pagination--------------");
      console.log(this.stock_models);
      // console.log(data, "上车成功");
      //显示第一个model，因为默认当前页是第一页
      bus.$emit("current_stock_model", this.stock_models[0]);
    });
  },
  beforeDestroy() {
    bus.$off("打卡");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ModelPagination.vue